import React, { Component } from 'react';
import { Modal, ModalFooter, ModalTitle, ModalBody, ModalHeader } from '@common/components/modal';
import { Button } from '@common/components/Button';
import { I18n } from 'react-redux-i18n';
import PropTypes from 'prop-types';
import cx from 'classnames';

import Settings from '../Settings';
import FormatCreate from './components/FormatCreate';

import '../../styles/ProfileFormatsManagement.scss';

export default class ProfileFormatsManagement extends Component {
    static propTypes = {
        close: PropTypes.func.isRequired,
        onDelete: PropTypes.func.isRequired,
        onCreate: PropTypes.func.isRequired,
        onChange: PropTypes.func.isRequired,
        formats: PropTypes.arrayOf(PropTypes.shape({
            name: PropTypes.string.isRequired,
            classes: PropTypes.array.isRequired,
            licensing: PropTypes.object.isRequired,
            useClassBased: PropTypes.bool.isRequired,
            defaultPatientsFolderId: PropTypes.number.isRequired,
            defaultPatientsFolderName: PropTypes.string,
            defaultFormats: PropTypes.object.isRequired,
        }))
    };

    static defaultProps = {

    };

    state = {
        selectedFormats: [],
        isOpenFormatCreate: false,
    };

    constructor(props) {
        super(props);

        let firstSelectedFormat = props.formats.length ? props.formats[0].name : undefined;
        const doesExistFormat = props.user.profileFormat && props.formats.find((format) => format.name === props.user.profileFormat);

        if (doesExistFormat) {
            firstSelectedFormat = props.user.profileFormat;
        }

        if (firstSelectedFormat) {
            this.state.selectedFormats.push(firstSelectedFormat);
        }
    }

    get currentSettingsData() {
        return this.props.formats.find((format) => format.name === this.state.selectedFormats[0]);
    }

    componentDidUpdate(prevProps) {
        if (this.props.formats.length > prevProps.formats.length) {
            this.closeFormatCreate();
        }
    }

    onFormatClick = (e) => {
		e.persist();
		
        const { name } = e.currentTarget.dataset;
        const { selectedFormats } = this.state;

        let newSelectedFormats = [name];

        if (e.ctrlKey || e.shiftKey) {
			newSelectedFormats = selectedFormats.includes(name)
				? selectedFormats.filter((formatID) => formatID !== name)
				: [...selectedFormats, name]
        }

        this.setState((state) => ({ 
            ...state,
            selectedFormats: newSelectedFormats
        }));
    }

    onLicensingChange = (name, useClassBased, licensing) => {
        this.props.onChange(name, { ...this.currentSettingsData, useClassBased, licensing });
    }

    onSecurityChange = (name, classes) => {
        this.props.onChange(name, { ...this.currentSettingsData, classes });
    }

    onFormatsChange = (name, defaultFormats) => {
        this.props.onChange(name, { ...this.currentSettingsData, defaultFormats });
    }

    onCreate = (name) => {
        this.props.onCreate(name);
    }

    onDelete = () => {
        this.props.onDelete(
            this.state.selectedFormats,
            (isConfirmed) => {
                if (isConfirmed) {
                    this.setState((state) => ({ ...state, selectedFormats: [] }));
                }
            }
        );
    }

    openFormatCreate = () => {
        this.setState((state) => ({ ...state, isOpenFormatCreate: true }));
    }

    closeFormatCreate = () => {
        this.setState((state) => ({ ...state, isOpenFormatCreate: false }));
    }

    render() {
        const { close, formats } = this.props;
        const { selectedFormats, isOpenFormatCreate } = this.state;

        return (
            <Modal 
                show
                backdrop="static"
                bsClass="bootstrap modal"
                className="ProfileFormatsManagement"
                dialogClassName="ProfileFormatsManagement__dialog"
                animation={false}
                onEscapeKeyDown={close}
                onHide={close}
            >
                <ModalHeader closeButton onHide={close} className="ProfileFormatsManagement__header">
                    <ModalTitle>{I18n.t('Profile Management')}</ModalTitle>
                </ModalHeader>
                <ModalBody>
                    {isOpenFormatCreate && <FormatCreate onSubmit={this.onCreate} close={this.closeFormatCreate} />}
                    <div className="ProfileFormatsManagement__content">
                        <div className="ProfileFormatsManagement__content__formats">
                            <div className="ProfileFormatsManagement__content__formats__data">
                                <span className="ProfileFormatsManagement__content__label">{I18n.t('Profile Formats')}</span>
                                <div className="ProfileFormatsManagement__content__formats__data__list">
                                    <section>
                                        {formats.map((format, index) => (
                                            <div
                                                id={'format-item' + index}
                                                key={format.name}
                                                data-name={format.name}
                                                className={cx(
                                                    'ProfileFormatsManagement__content__formats__data__list__item',
                                                    { ['ProfileFormatsManagement__content__formats__data__list__item-selected']: selectedFormats.includes(format.name) },
                                                )}
                                                onClick={this.onFormatClick}
                                            >
                                                <span data-name={format.name}>{format.name}</span>
                                            </div>
                                        ))}
                                    </section>
                                </div>
                            </div>

                            <div className="ProfileFormatsManagement__content__formats__controls">
                                <Button id="btn-pf-add-fmt" onClick={this.openFormatCreate}>{I18n.t('Add Format')}</Button>
                                <Button id="btn-pf-delete-fmt" disabled={selectedFormats.length === 0} onClick={this.onDelete}>{I18n.t('Delete Format')}</Button>
                            </div>
                        </div>
                        {Boolean(selectedFormats.length && selectedFormats.length === 1) && (
                            <div className="ProfileFormatsManagement__content__settings">
                            <span className="ProfileFormatsManagement__content__label">{I18n.t('Settings')}</span>
                                <Settings 
                                    data={this.currentSettingsData}
                                    tabsToShow={{
                                        security: true,
                                        licensing: true,
                                        formats: true,
                                        ambryIDs: false,
                                    }}
                                    methods={{
                                        licensing: {
                                            onChange: this.onLicensingChange
                                        },
                                        security: {
                                            onChange: this.onSecurityChange
                                        },
                                        formats: {
                                            onChange: this.onFormatsChange
                                        },
                                    }}
                                />
                            </div>
                        )}
                    </div>
                </ModalBody>
            </Modal>
        );
    }
}